import { z } from 'zod';

import { zodAddressSchema } from '@vestigas/data';

import { EmailSchema, isValidGln } from '@vestigas/utils';

import { VOLUME_BUCKET } from './constants';

/** GS1 GLN: 13 digits with a valid mod-10 check digit. */
export const zodGlnSchema = z.string().refine(isValidGln);

/** VAT ID: 2-letter country code + 2–13 alphanumerics. */
export const zodVatIdSchema = z.string().regex(/^[A-Z]{2}[0-9A-Z]{2,13}$/);

export const zodCompanyRefSchema = z.object({
  id: z.uuid(),
  name: z.string(),
});

export const zodCompanyAccountRefSchema = z.object({
  id: z.uuid(),
  name: z.string(),
});

export const zodResolvedCompanyRefSchema = z.object({
  companyAccount: zodCompanyAccountRefSchema,
  id: z.uuid(),
  name: z.string(),
});

export const zodSubmittedSupplierInfoSchema = z.object({
  address: zodAddressSchema.nullish(),
  contactEmail: EmailSchema.nullish(),
  dlnCountRange: z.enum(VOLUME_BUCKET).nullish(),
  gln: z.string().nullish(),
  hra: z.string().nullish(),
  hraRegisterCourt: z.string().nullish(),
  hrb: z.string().nullish(),
  invCountRange: z.enum(VOLUME_BUCKET).nullish(),
  note: z.string().nullish(),
  registerCourt: z.string().nullish(),
  revenue: z.string().nullish(),
  supplierName: z.string(),
  vatId: z.string().nullish(),
});

export const zodPriorRejectionRefSchema = z.object({
  rejectedAt: z.iso.datetime({ offset: true }).nullish(),
  rejectionReason: z.string().nullish(),
  requestId: z.uuid(),
  submittedSupplierName: z.string().nullish(),
});
